import React, { FC, TextareaHTMLAttributes } from 'react';
import Textarea, { TextareaProps } from '../../elements/Textarea';
import styles from './styles.module.scss';

interface FormTextareaProps extends TextareaProps {
    info?: string,
    label?: string,
}

const FormTextarea: FC<FormTextareaProps & TextareaHTMLAttributes<HTMLTextAreaElement>> = ({
    info,
    label,
    ...props
}): JSX.Element => {
    return (
        <div
            className={[
                styles.group,
                props.error && styles.hasError,
            ].join(' ')}
        >
            {label && <label className={styles.label}>
                {label}
                {props.required && <span>*</span>}
            </label>}
            <Textarea {...props} />
            <p className={styles.info}>{typeof props.error === 'string' ? props.error : info}</p>
        </div>
    )
}

export default FormTextarea;
